import { createPortal } from 'react-dom';

export default function Portal({ children, containerSelector }) {
  const container = document.querySelector(containerSelector);

  return container ? createPortal(children, container) : null;
}
